var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.condition)?_c('div',{staticClass:"list-item row"},[_c('div',[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.label))])]),_c('div',[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.value))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }